import { Button, DatePicker, Input, message, Select } from "antd";
import { useFormik } from "formik";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  AddUserReports,
  addUserReports,
  userReportFields,
  userReportLinkExp,
} from "../../actions/reports";
import { objectToFormData } from "../../utils";
import { useLocation } from "react-router-dom";

const { Option } = Select;

const AddReport = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [validationSchema, setValidationSchema] = React.useState(null);
  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (vals) => {
      let arr = [];
      Object.keys(vals).forEach((ele) => {
        arr.push({
          id: ele,
          value: vals[ele],
        });
      });
      if (props.report?.id) {
        dispatch(addUserReports({ field_values: arr, id: props.report?.id }));
      } else {
        dispatch(addUserReports({ field_values: arr }));
      }
    },
  });

  const userReportFieldsResponse = useSelector(
    (state) => state.reports.userReportFields || {},
  );

  const addUserReportsResponse = useSelector(
    (state) => state.reports.addUserReports || {},
  );

  const { data: { response: { fields = [] } = {} } = {} } =
    userReportFieldsResponse;

  React.useEffect(() => {
    if (addUserReportsResponse?.data?.status) {
      formik.resetForm();
      props.handleCancel();
      dispatch({
        type: AddUserReports.RESET,
      });
      if (location?.state?.expense_id) {
        const payload = {};
        payload.id = addUserReportsResponse?.data?.response?.report?.id;
        payload.transactions = [location?.state?.expense_id];
        dispatch(userReportLinkExp(objectToFormData({ ...payload })));
      }

      if (props.report?.id) {
        props.callOnMount && props.callOnMount();
      }
    }

    if (addUserReportsResponse?.data?.status === false) {
      dispatch({
        type: AddUserReports.RESET,
      });
    }
    // eslint-disable-next-line
  }, [addUserReportsResponse]);

  React.useEffect(() => {
    if (props.report?.id) {
      dispatch(
        userReportFields({
          id: props.report?.id,
        }),
      );
    } else {
      dispatch(userReportFields());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.report]);

  React.useEffect(() => {
    if (fields && fields?.length > 0 && props.report?.id) {
      let arr = {};
      fields.forEach((item) => {
        arr[item.field_id] =
          item.field_type === "dropdown" && item.selected.id
            ? item.selected.id
            : item.selected.value || "";
      });
      formik.setValues({
        ...arr,
      });
    }

    if (fields && fields?.length) {
      let obj = {};
      let obj2 = {};
      fields.forEach((item) => {
        if (item.is_required) {
          obj2[item.field_id] = "";
          obj[item.field_id] = Yup.string().required(
            `${item.display_name} is required`,
          );
        }
      });
      if (!props.report?.id)
        formik.setValues({
          ...formik.values,
          ...obj2,
        });
      setValidationSchema(Yup.object().shape(obj));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportFieldsResponse]);

  const handleCancelButton = () => {
    formik.resetForm();
    props.handleCancel();
  };

  const handleChange = (val, id) => {
    formik.setFieldValue(id, val);
  };

  const renderDataTypes = (value, default_values, id, display_name) => {
    switch (value) {
      case "string":
        return (
          <>
            <Input
              placeholder={`Enter ${display_name}`}
              value={formik.values?.[id] ? formik.values?.[id] : ""}
              style={{ minWidth: "216px" }}
              onChange={(e) => {
                handleChange(e.target.value.trimStart(), id);
              }}
            />
            <div className="error">
              {formik.touched?.[id] && formik.errors?.[id]}
            </div>
          </>
        );
      case "integer":
        return (
          <>
            <Input
              placeholder={`Enter ${display_name}`}
              type="text"
              value={formik.values?.[id] ? formik.values?.[id] : ""}
              style={{ minWidth: "216px" }}
              onChange={(e) => {
                if (Number.isNaN(Number(e.target.value))) {
                  return;
                }
                handleChange(e.target.value.trimStart(), id);
              }}
            />
            <div className="error">
              {formik.touched?.[id] && formik.errors?.[id]}
            </div>
          </>
        );
      case "dropdown":
        return (
          <>
            <Select
              style={{ width: 200 }}
              placeholder={`Select ${display_name}`}
              value={formik.values?.[id]}
              onChange={(val) => {
                handleChange(val, id);
              }}
            >
              {default_values &&
                default_values.map(({ id, value }) => (
                  <Option key={id} value={id}>
                    {value}
                  </Option>
                ))}
            </Select>
            <div className="error">
              {formik.touched?.[id] && formik.errors?.[id]}
            </div>
          </>
        );
      case "datetime":
        return (
          <>
            <DatePicker
              value={
                formik.values?.[id]
                  ? moment(formik.values?.[id], [
                    "DD MMM'YY, HH:mm:ss a",
                    "YYYY-MM-DD HH:mm:ss",
                  ])
                  : null
              }
              onChange={(date, dateString) => {
                handleChange(dateString, id);
              }}
              showTime
            />
            <div className="error">
              {formik.touched?.[id] && formik.errors?.[id]}
            </div>
          </>
        );
      default:
      // code block
    }
  };

  return (
    <>
      <form
        layout="vertical"
        className="modal-form"
        onSubmit={formik.handleSubmit}
      >
        {fields.length &&
          fields.map((item) => (
            <div className="nameItem">
              <label
                className={`inline-block ${item.is_required ? "required" : ""}`}
              >
                {item.display_name}
              </label>
              <br />
              {renderDataTypes(
                item.field_type,
                item.default_values,
                item.field_id,
                item.display_name,
              )}
            </div>
          ))}
        <div>
          <Button
            key="1"
            htmlType="submit"
            className="formButton mt3 primaryButton"
            disabled={addUserReportsResponse?.loading}
          >
            Submit
          </Button>
          <Button
            key="2"
            className="cancelButton ml1 mt3 "
            onClick={() => handleCancelButton()}
          >
            Cancel
          </Button>
        </div>
      </form>
    </>
  );
};

export default AddReport;
